// frontend/src/components/account/InvoiceStatusTag.jsx
import { Tag } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const InvoiceStatusTag = ({ status }) => {
  switch (status) {
    case "paid":
      return <Tag color="success" icon={<CheckCircleOutlined />}>Paid</Tag>;
    case "open":
      return <Tag color="warning" icon={<ClockCircleOutlined />}>Pending</Tag>;
    case "draft":
      return <Tag color="default" icon={<ClockCircleOutlined />}>Draft</Tag>;
    case "void":
      return <Tag color="error" icon={<CloseCircleOutlined />}>Void</Tag>;
    default:
      return <Tag>{status}</Tag>;
  }
};

export default InvoiceStatusTag;